<template>
  <PreviewModal
    :is-visible="isModalVisible"
    @close="closeModal"
  />

  <button class="btn btn-info" title="Preview" @click="isModalVisible = true"><i class="icon-alt icon-play"></i>Preview</button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PreviewModal from '~/components/preview/PreviewModal.vue';

export default defineComponent({
  name: 'PreviewButton',
  components: {
    PreviewModal,
  },
  data() {
    return {
      isModalVisible: false,
    };
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
    }
  }
});
</script>
